import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './core/guards/auth.guard';

const routes: Routes = [
    {
        path: 'devconf',
        loadChildren: () => import('./modules/main/main.module').then(m => m.MainModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'login',
        pathMatch: 'full',
        loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
    },
    {
        path: 'forgot-password',
        pathMatch: 'prefix',
        loadChildren: () => import('./modules/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
    },
    {
        path: '',
        redirectTo: 'devconf',
        pathMatch: 'full'
    },
    {
        path: '**',
        loadChildren: () => import('./shared/components/404/404.module').then(m => m.NotFoundModule),
        canLoad: [AuthGuard]
    }
];


@NgModule({
    imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
